import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const currentOrder = () => gql`
  query currentOrder($params: CurrentOrderParams) {
    currentOrder(params: $params) {
      id
      uuid
      orderGroupId
      status
      deliveryType
      orderDetails {
        id
        quantity
        price
        product {
          id
          uuid
          imagesUrl
          prescriptionType
          price
          discount {
            type
            price
            listPrice
          }
        }
        order {
          id
        }
      }
      paymentMethod {
        id
        uuid
        type
        data
      }
      address {
        id
        name
        street
        streetNumber
        commune
        details
        apartment
      }
      user {
        id
      }
      metadata {
        userInfo {
          email
          name
          rut
        }
        useMekiCredits
        installments
        localVendor {
          paymentMethod
          mixPayments
        }
        assistantVendor {
          paymentMethod
        }
        sendEmail
        chargeDeliveryCost
        insuranceInfo {
          claimId
          insuranceId
          rut
          totalReimbursement
          totalDeductible
          totalCopay
          reimbursedProducts {
            sku
            observation
            unitReimbursement
            unitCopay
            unitDeductible
            quantity
            coverage
          }
        }
      }
    }
  }
`;

export type CurrentOrderQueryResponse = { currentOrder: Order };

export type CurrentOrderQueryParams = ResolverParams<{ orderUuid?: string }>;
